import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { downloadByURL } from "utils/download";
import type { McpDocumentDownload } from "./mcpDocumentDownloadQuery";

export async function runMcpDocumentDownload(download: McpDocumentDownload) {
  const projectId = projectsDataStore.projectId;
  const url = download.uniqueId
    ? API_URL.FILES.getFileByIdAndUniqueId(projectId, download.fileId, download.uniqueId)
    : API_URL.FILES.getFileById(projectId, download.fileId);
  await downloadByURL(url);
}
